import React from 'react';
const common = require('../common/common');
const ticketCommon = require('../common/ticketCommon.jsx');
const env = require("../../config.js").default;

export class FilterSubTypes extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            actualSubTypes: [],
            folder: this.props.folder,
            subtypes: props.subtypes,
        };
    }

    componentDidMount() {
        const $ = window.$;
        $(window).resize(() => $('.select2').css('width', "100%"));

        const addSelectAll = matches => {
            if (matches.length > 0) {
                return [
                    { id: 'selectAll', text: common.getTrad('Seleziona tutti'), matchIds: matches.map(match => match.id) },
                    ...matches
                ];
            }
        };

        $('.subTypes').select2({
            allowClear: true,
            sorter: addSelectAll,
            language: common.getLanguage(),
            placeholder: common.getTrad("Seleziona una sotto tipologia"),
            dropdownParent: $('#collapseFiltri'),
            dropdownAutoWidth: true,
        });

        // attach handlers once
        $('#subTypes').on('select2:select', (e) => {
            if (e.params.data.id === 'selectAll') {
                $('#subTypes').val(e.params.data.matchIds).trigger('change');
                return;
            }
            this.state.actualSubTypes = $('#subTypes').val();
            this.changeFilterHandler();
            $('#subTypeDot').css('visibility', $('#subTypes').val().length > 0 ? 'visible' : 'hidden');
        });

        $('#subTypes').on('select2:unselect', () => {
            this.state.actualSubTypes = $('#subTypes').val();
            $('#subTypeDot').css('visibility', $('#subTypes').val().length > 0 ? 'visible' : 'hidden');
            this.changeFilterHandler();
        });

        this.syncFromIndexedDB();
    }

    componentWillUnmount() {
        window.$('#subTypes').off('select2:select select2:unselect');
    }

    changeFilterHandler = () => {
        //common.add_UX_data(this.state.folder, "Filters", "SubType_filter", this.state.actualSubTypes);
        this.props.sendData(this.state.actualSubTypes);
    }

    syncFromIndexedDB() {
        const $ = window.$;
        common.get_UX_component(this.state.folder, "Filters", "SubType_filter").then((subtypes) => {
            const stored = (subtypes !== undefined && subtypes !== null && subtypes.length > 0) ? subtypes : null;
            $('#subtypeDot').css('visibility', stored !== null ? 'visible' : 'hidden');
            this.setState({ actualSubTypes: stored }, () => {
                this.changeFilterHandler();
                this.setSelectValueWithRetry(stored, 8, 150);
            });
        });
    }

    setSelectValueWithRetry(value, attempts = 5, interval = 200) {
        const $ = window.$;
        const trySet = (remaining) => {
            if (!value || (Array.isArray(value) && value.length === 0)) {
                $('#subTypes').val([]).trigger('change');
                return;
            }
            const vals = Array.isArray(value) ? value : [value];
            const allExist = vals.every(v => $('#subTypes option[value="' + v + '"]').length > 0);
            if (allExist) {
                $('#subTypes').val(vals).trigger('change');
                return;
            }
            if (remaining > 0) {
                window.setTimeout(() => trySet(remaining - 1), interval);
            } else {
                $('#subTypes').val(vals).trigger('change');
            }
        };
        trySet(attempts);
    }

    componentDidUpdate(prevProps) {
        window.$('.select2').css('width', "100%");
        // Re-sync when options update (e.g. after back navigation when props reload)
        if (prevProps.subtypes !== this.props.subtypes) {
            this.syncFromIndexedDB();
        }
    }

    static getDerivedStateFromProps(props, state) {
        if (props.subtypes !== state.subtypes) {
            return { subtypes: props.subtypes };
        }
        return null;
    }

    render(props) {
        return (
            <div className={(this.props.customClass !== undefined && this.props.customClass !== '' ? this.props.customClass : "col-xl-6 col-lg-6") + " col-md-12 col-sm-12 col-xs-12 row-eq-height"} role="alert" id="ricerca_filtro_subtype">
                <div className="col-12 p-0">
                    <p>{common.getTrad("Filtra Sotto Tipologie")}<span> </span><span id="subTypeDot" className="orange-dot" style={{ visibility: 'hidden', position: 'absolute', left: '-9px', top: '7px' }}></span></p>
                    <div className="form-group">
                        <select name="sotto_tipologie" className="form-control subTypes" id="subTypes" multiple="multiple">
                            {this.state.subtypes !== undefined ?
                                Object.keys(this.state.subtypes).map((index, key) => {
                                    let elem = this.state.subtypes[index];
                                    return (<option key={key} data-tipologia={elem.id} value={elem.id}>{elem.titolo}</option>);
                                })
                                : ""
                            }
                        </select>
                    </div>
                </div>
            </div>
        )
    }
}
